import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { TickedDiscountItem } from 'components';
import { TextSmall } from 'components/chroma/extended';
import { QuotePriceExcessInfo } from 'scenes/common/components/QuotePriceExcessInfo';
import { FunnelType } from 'scenes/common/flows/types';
import { getDecodedStrippedString } from 'scenes/common/helpers/html';
import { DEFAULT_ONLINE_CAMPAIGN } from 'scenes/common/helpers/insuranceInfo';
import { toPercentage } from 'scenes/common/helpers/percentage';
import { useIsLargeScreen } from 'scenes/common/hooks/useMedia';
import { Campaign } from 'scenes/common/types';
import { SCREEN } from 'scenes/common/types/screen';
import { suppressOfferApplied } from 'scenes/motor/helpers/campaign';

const FootnoteWrapper = styled.div`
  margin-top: -0.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: ${SCREEN.LARGE}px) {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const Footnotes: FunctionComponent<{
  comprehensiveSelected: boolean;
  thirdPartySelected: boolean;
  campaign?: Campaign;
  excess?: number;
}> = ({ comprehensiveSelected, thirdPartySelected, campaign, excess }) => {
  const isLargeScreen = useIsLargeScreen();
  return (
    <FootnoteWrapper>
      {isLargeScreen && (
        <TickedDiscountItem
          campaignDescription={`${toPercentage(
            DEFAULT_ONLINE_CAMPAIGN.discount
          )} online discount applied`}
          suppressOfferApplied={suppressOfferApplied}
        />
      )}
      {campaign && (
        <TickedDiscountItem
          campaignDescription={getDecodedStrippedString(
            campaign.elements[0].description
          )}
          suppressOfferApplied={suppressOfferApplied}
        />
      )}
      <QuotePriceExcessInfo
        funnelType={FunnelType.Motor}
        excess={excess}
        thirdPartySelected={thirdPartySelected}
        comprehensiveSelected={comprehensiveSelected}
      />
      <TextSmall margin={{ bottom: 0 }}>
        * Includes GST, government charges and any discount.
      </TextSmall>
      {thirdPartySelected && (
        <TextSmall>
          Our third party covers do not include Compulsory Third Party (CTP)
          Insurance.
        </TextSmall>
      )}
    </FootnoteWrapper>
  );
};

export default Footnotes;
